


































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class PhoneMockup extends Vue {
  @Prop({ default: '311' }) readonly width?: string;
  @Prop({ default: '632' }) readonly height?: string;
  @Prop({ default: '#92A2B0' }) readonly fill?: string;
}
